import axios from 'axios'
import config from '../../../config/environment'
import store from '../../index'
import i18n, { strings } from '../../../i18n'
import { INIT } from '../type'
import queryString from 'query-string'
import { modalServerAction } from './action'
import findOutDestination from '../../../components/MobileExchenger/function/findOutDestination'
import minMaxLimit from '../../../components/MobileExchenger/function/limits'

import * as Sentry from "@sentry/react";

import Log from '../../../components/SentryLogs/Log'

const { dispatch } = store

export default async function MobileBuy() {

    const url = window.location.href
    const urlParamsString = url.slice((url.indexOf('?')) + 1)
    const urlParamsObj = queryString.parse(urlParamsString)
    const cashbackToken = urlParamsObj.cashbackToken

    Sentry.setUser({ username: cashbackToken });
    Sentry.setTag("LOG_CASHBACK", cashbackToken)

    const version = urlParamsObj.version
    Sentry.setTag("LOG_VERSION", version)

    let versionNumber = version.toString().split(' ')[1] ? version.toString().split(' ')[1] : version.toString().split('_')[1] ? version.toString().split('_')[1] : null
    versionNumber = versionNumber === 'tester' ? version.split('_')[2] : versionNumber

    if (!urlParamsObj.cashbackToken || !urlParamsObj.message || !urlParamsObj.messageHash || !urlParamsObj.signature) {
        window.open('/', '_self');
    }

    Log.info(`V3_BUY.MobileBuyAction time before get WalletData ${JSON.stringify(new Date())}`)
    let response = await axios.get(config.backendUrl + '/data/wallet?message=' + urlParamsObj.message + '&messageHash=' +
        urlParamsObj.messageHash + '&signature=' + urlParamsObj.signature + '&cashbackToken=' + cashbackToken)
        .catch(error => {
            console.log(error.message)
            if (error.response) {
                console.log(error.response.data.message)
                Log.info(`V3_BUY.MobileBuyAction get WalletData error time ${JSON.stringify(new Date())}`)
                Log.error(`V3_BUY.MoileBuyAction get walletData error ${error.response.data.message}`)
                Log.captureError('V3_BUY.MoileBuyAction get walletData error')
                // alert(error.response.data.message)
                dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
            }
        })
    Log.info(`V3_BUY.MobileBuyAction time after get WalletData ${JSON.stringify(new Date())}`)
    const walletData = response ? response.data : null

    Log.info(`V3_BUY.MobileBuyAction time before get data/all ${JSON.stringify(new Date())}`)
    response = await axios.get(config.backendUrl + '/data/all')
        .catch(error => {
            console.log(error.message)
            if (error.response) {
                console.log(error.response.data.message)
                Log.info(`V3_BUY.MobileBuyAction get data/all error time ${JSON.stringify(new Date())}`)
                Log.error(`V3_BUY.MoileBuyAction get activeExchangeWays error ${error.response.data.message}`)
                Log.captureError('V3_BUY.MoileBuyAction get activeExchangeWays error')
                // alert(error.response.data.message)
                dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
            }
        })
    Log.info(`V3_BUY.MobileBuyAction time after get data/all ${JSON.stringify(new Date())}`)

    const activeExchangeWays = response ? response.data : null

    if (activeExchangeWays === null) {
        dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
    }

    const allExchangeWays = activeExchangeWays ? [...activeExchangeWays.buy] : []

    // const limitsArray = allExchangeWays.map(way => way.limits)
    let currencyCode

    if (walletData !== null) {
        currencyCode = typeof walletData.selectedCurrency !== 'undefined' ? walletData.selectedCurrency : false
        if (typeof walletData.wallets !== 'undefined') {
            walletData.wallets.map((item) => {
                Sentry.setTag("LOG_WALLET", item.walletHash)
                if (item.cashbackToken && item.cashbackToken === null) {
                    dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
                }
            })
        }

        Sentry.setTag("LOG_TOKEN_FULL", walletData.deviceToken)

        if (typeof walletData.cards !== 'undefined') {
            if (walletData.cards.length !== 0) {
                const cards = walletData.cards.filter(card => card.type === 'visa' || card.type === 'mastercard' || card.type === 'mir' ||
                    card.type === 'maestro').map(item => {
                        return (
                            {
                                id: item.id,
                                data: JSON.stringify({ number: item.number, countryCode: item.countryCode, expirationDate: item.expirationDate })
                            }
                        )
                    })
                if (cards.length > 1) {
                    for (let i = 0; i < cards.length - 1; i++) {
                        for (let j = i + 1; j < cards.length; j++) {
                            if (JSON.stringify(cards[i].data) === JSON.stringify(cards[j].data)) {
                                window.ReactNativeWebView.postMessage(JSON.stringify({ 'deleteCard': cards[j].id }))
                                const index = walletData.cards.indexOf(walletData.cards.find(item => item.id === cards[j].id))
                                walletData.cards.splice(index, 1)
                            }
                        }
                    }
                }
            }
        }
    }

    try {
        i18n.changeLanguage(walletData.locale)
    } catch (e) {
        dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
    }

    let outCurrency, inCurrency, payway, minMaxLimits
    const outCurrencyCode = localStorage.getItem('outCurrencyBuy')

    try {
        if (outCurrencyCode) {
            const isActive = walletData ? walletData.wallets.find(wallet => wallet.cashbackToken === cashbackToken).accounts.filter(item => item.isHidden !== 1).map(item => item.currencyCode) : null
            const currencyArray = Array.from(new Set(allExchangeWays.filter(way => isActive.includes(way.outCurrency.code)).map(way => way.outCurrency.code)))
            if (currencyCode !== false) {
                outCurrency = currencyCode
            } else if (currencyArray.includes(outCurrencyCode)) {
                outCurrency = outCurrencyCode
            } else {
                outCurrency = 'BTC'
            }

            localStorage.setItem('outCurrencyBuy', outCurrency)
        } else {
            outCurrency = 'BTC'
            localStorage.setItem('outCurrencyBuy', outCurrency)
        }
    } catch (e) {
        Log.error(`V3_BUY.MoileBuyAction get outCurrencyCode error ${JSON.stringify(e)}`)
        Log.captureError('V3_BUY.MoileBuyAction get outCurrencyCode error')
        dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
    }

    const { outDestination, walletName } = findOutDestination(walletData, outCurrency, cashbackToken)

    const inCurrencyCode = localStorage.getItem('inCurrencyBuy')

    try {
        if (inCurrencyCode) {
            const currencyArray = Array.from(new Set(allExchangeWays.map(way => way.inCurrency.code)))
            if (currencyArray.includes(inCurrencyCode)) {
                inCurrency = inCurrencyCode
            } else {
                inCurrency = null
            }
        } else {
            inCurrency = null
        }
    } catch (e) {
        Log.error(`V3_BUY.MoileBuyAction get inCurrencyCode error ${JSON.stringify(e)}`)
        Log.captureError('V3_BUY.MoileBuyAction get inCurrencyCode error')
        dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
    }

    const inPaywayCode = localStorage.getItem('TrusteeWalletInPaywayBuy')

    try {
        if (inPaywayCode) {
            const payways = inCurrency ?
                Array.from(new Set(allExchangeWays.filter(way => way.inCurrency.code === inCurrency && outCurrency ? way.outCurrency.code === outCurrency : null).map(way => way.inPaywayCode))) : []
            if (payways.includes(inPaywayCode)) {
                payway = inPaywayCode
            } else {
                payway = null
            }
        } else {
            payway = null
        }
    } catch (e) {
        Log.error(`V3_BUY.MoileBuyAction get inPaywayCode error ${JSON.stringify(e)}`)
        Log.captureError('V3_BUY.MoileBuyAction get inPaywayCode error')
        dispatch(modalServerAction(true, strings('mobileExchanger.modal.serverRespond')))
    }

    if (inCurrency && outCurrency && payway) {
        minMaxLimits = minMaxLimit(allExchangeWays, inCurrency, outCurrency, 'FLOATING', payway, 'BUY', [])
    }

    Log.info(`V3_BUY.MoileBuyAction init data ${JSON.stringify({ cashbackToken, inCurrency, outCurrency, payway, minMaxLimits: JSON.stringify(minMaxLimits), outDestination })}`)


    let card = typeof walletData.cards !== 'undefined' && walletData.cards ? walletData.cards.filter(way => way.type === 'visa' || way.type === 'mastercard' || way.type === 'mir' || way.type === 'maestro') : []
    const cardNumbers = card.length ? card.map(item => item.number) : []
    let res
    try {
        if (cardNumbers.length) {
            res = await axios.get(config.backendUrl + `/payment-details/validation-status?cardNumber=${cardNumbers.join()}`)
            res = res.data
            if (card.length > 1) {
                card = card.map((item) => {
                    const tempCards = res.find(way => way.cardNumber === item.number)
                    let data = typeof item.cardVerificationJson !== 'undefined' && item.cardVerificationJson ? JSON.parse(item.cardVerificationJson) : null
                    data = {
                        ...data,
                        verificationStatus: tempCards.verificationStatus
                    }
                    if (typeof tempCards.message !== 'undefined') {
                        data.message = tempCards.message
                    }
                    if (typeof tempCards.firstName !== 'undefined') {
                        data.firstName = tempCards.firstName
                    }
                    if (typeof tempCards.lastName !== 'undefined') {
                        data.lastName = tempCards.lastName
                    }
                    if (typeof tempCards.updatedAt !== 'undefined') {
                        data.updatedAt = tempCards.updatedAt
                    }
                    return (
                        {
                            ...item,
                            cardVerificationJson: JSON.stringify(data)
                        }
                    )
                })
            } else if (card.length === 1) {
                let data = typeof card[0].cardVerificationJson !== 'undefined' && card[0].cardVerificationJson ? JSON.parse(card[0].cardVerificationJson) : null
                data = {
                    ...data,
                    verificationStatus: res.verificationStatus
                }
                if (typeof res.message !== 'undefined') {
                    data.message = res.message
                }
                if (typeof res.firstName !== 'undefined') {
                    data.firstName = res.firstName
                }
                if (typeof res.lastName !== 'undefined') {
                    data.lastName = res.lastName
                }
                if (typeof res.updatedAt !== 'undefined') {
                    data.updatedAt = res.updatedAt
                }
                card = [{
                    ...card[0],
                    cardVerificationJson: JSON.stringify(data)
                }]
            }
        }
        if (typeof walletData.cards !== 'undefined') {
            walletData.cards = [
                ...walletData.cards.filter(way => way.type !== 'visa' && way.type !== 'mastercard' && way.type !== 'mir' && way.type !== 'maestro'),
                ...card
            ]
        }

    } catch (e) {
        console.log(e.response.data)
    }

    dispatch({
        type: INIT,
        allExchangeWays,
        walletData,
        screen: 1,
        cashbackToken,
        inCurrency,
        outCurrency,
        payway,
        minMaxLimits: minMaxLimits || {},
        outDestination,
        walletName,
        rateProvider: 'FLOATING',
        version,
        versionNumber,
        sign: {
            message: urlParamsObj.message,
            messageHash: urlParamsObj.messageHash,
            signature: urlParamsObj.signature
        }
    })
}